import { useCarouselContext } from 'src/lib/Utils/Contexts/Carousel';

const CurrentSlideIndicator = ({ isHidden }: { isHidden?: boolean }) => {
  const { state } = useCarouselContext();

  return (
    <div
      className={`js-carousel-indicator relative ${isHidden ? 'sr-only' : ''}`}
      data-testid="carousel-indicator"
    >
      <span
        aria-live="polite"
        className="absolute right-0 px-8 py-4 text-sm bg-teal-darker text-white"
      >
        Slide <strong>{state.activeSlide + 1}</strong> of {state.totalSlides}
      </span>
    </div>
  );
};

export default CurrentSlideIndicator;
